import { useRef, useState } from 'react';
import { useLang } from '../i18n';

// Cada módulo: [temas en castellano, temas en catalán]
const MODULES = [
  [['Saludos', 'To Be', 'Home'], ['Salutacions', 'To Be', 'Home']],
  [['Present Simple', 'Adverbios de tiempo', 'Rutinas'], ['Present Simple', 'Adverbis de temps', 'Rutines']],
  [['Present Continuous', 'Comparativos', 'Superlativos'], ['Present Continuous', 'Comparatius', 'Superlatius']],
  [['Past Simple & Continuous', 'Viajes', 'Preposiciones de lugar'], ['Past Simple & Continuous', 'Viatges', 'Preposicions de lloc']],
  [['Futuro', 'Modal Verbs', 'Preposiciones de tiempo'], ['Futur', 'Modal Verbs', 'Preposicions de temps']],
  [['Phrasal Verbs', 'Present Perfect', 'Present Perfect Continuous'], ['Phrasal Verbs', 'Present Perfect', 'Present Perfect Continuous']],
  [['Modal Verbs', 'Permisos', 'Obligaciones'], ['Modal Verbs', 'Permisos', 'Obligacions']],
  [['Reported Speech', 'Voz pasiva', 'Phrasal Verbs'], ['Reported Speech', 'Veu passiva', 'Phrasal Verbs']],
  [['Revisión completa', 'Proyecto final'], ['Revisió completa', 'Projecte final']],
];

export default function ModuleExplorer() {
  const { t, lang } = useLang();
  const [active, setActive] = useState(0);
  const tabRefs = useRef([]);
  const idx = lang === 'ca' ? 1 : 0;
  const total = MODULES.length;
  const topics = MODULES[active][idx];

  const select = (i, focus) => {
    const next = (i + total) % total;
    setActive(next);
    if (focus) tabRefs.current[next]?.focus();
  };

  const onKeyDown = (event, i) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') { event.preventDefault(); select(i + 1, true); }
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') { event.preventDefault(); select(i - 1, true); }
  };

  return (
    <div className="module-explorer">
      <div className="module-tabs" role="tablist" aria-label={t('Módulos de SEN Pro', 'Mòduls de SEN Pro')} aria-orientation="vertical">
        {MODULES.map((module, i) => (
          <button
            key={i}
            ref={el => { tabRefs.current[i] = el; }}
            type="button"
            role="tab"
            id={`module-tab-${i}`}
            aria-selected={active === i}
            aria-controls="module-panel"
            tabIndex={active === i ? 0 : -1}
            className={`module-tab ${active === i ? 'is-active' : ''} ${i < active ? 'is-past' : ''}`}
            onClick={() => select(i)}
            onMouseEnter={(event) => { if (event.pointerType === 'mouse' || !event.pointerType) setActive(i); }}
            onKeyDown={event => onKeyDown(event, i)}
          >
            <span className="module-tab-num">{String(i + 1).padStart(2, '0')}</span>
            <span className="module-tab-copy">
              <strong>{t('Módulo', 'Mòdul')} {i + 1}</strong>
              <small>{module[idx].slice(0, 2).join(' · ')}</small>
            </span>
            <span className="module-tab-arrow" aria-hidden="true">→</span>
          </button>
        ))}
      </div>

      <div className="module-panel" id="module-panel" role="tabpanel" aria-labelledby={`module-tab-${active}`} key={active}>
        <span className="module-panel-bg" aria-hidden="true">{String(active + 1).padStart(2, '0')}</span>
        <span className="module-panel-label">{t('MÓDULO', 'MÒDUL')} {active + 1} / {total}</span>
        <h3>{active === total - 1 ? t('Todo junto, en práctica', 'Tot junt, en pràctica') : t('Lo que vas a aprender', 'El que aprendràs')}</h3>
        <ul className="module-chips">
          {topics.map((topic, i) => <li key={topic + i} style={{ animationDelay: `${i * 70}ms` }}>{topic}</li>)}
        </ul>
        <div className="module-progress" aria-hidden="true"><span style={{ width: `${((active + 1) / total) * 100}%` }} /></div>
        <div className="module-panel-nav">
          <button type="button" onClick={() => select(active - 1)} aria-label={t('Módulo anterior', 'Mòdul anterior')}>←</button>
          <button type="button" onClick={() => select(active + 1)} aria-label={t('Módulo siguiente', 'Mòdul següent')}>→</button>
        </div>
      </div>
    </div>
  );
}
